<template>
  <div class="container-fluid">
    <Toolbar class="m-2">
      <template #start>
        <h2>{{ $t("nav.tag") }}</h2>
      </template>
      <template
        #end
      >
        <Button
          class="p-button-rounded p-button-outlined"
          icon="pi pi-plus"
          :label="$t('action.crud.create')"
          @click="showCreateForm = true"
        />
      </template>
    </Toolbar>

    <BarcodeAdvancedFilter
      v-model:stakeholder-id="barcodeFilter.filters.stakeholderId.value"
      v-model:duplex-high="barcodeFilter.filters.lineIdFilter.duplexHigh.value"
      v-model:duplex-low="barcodeFilter.filters.lineIdFilter.duplexLow.value"
      v-model:mainVenue="barcodeFilter.filters.lineIdFilter.mainVenue.value"
      v-model:licencePeriod="barcodeFilter.filters.lineIdFilter.licencePeriod.value"
      v-model:start-date="barcodeFilter.filters.lineIdFilter.startDate.value"
      v-model:end-date="barcodeFilter.filters.lineIdFilter.endDate.value"
      v-model:code="barcodeFilter.filters.code.value"
      @validate="getBarcodes"
      @reset="resetFilter"
    />

    <BarcodeTable
      v-model:sortField="barcodeFilter.pageable.sortField"
      v-model:sortOrder="barcodeFilter.pageable.sortOrder"
      v-model:filters="barcodeFilter.filters"
      v-model:rows="barcodeFilter.pageable.size"
      paginator
      paginator-position="both"
      :value="tags"
      show-delete-button
      show-detail-button
      show-edit-button
      :total-records="totalItemsCount"
      @sort="getBarcodes"
      @filter="getBarcodes"
      @delete="getBarcodes"
      @page="onPageChange($event)"
    />

    <BarcodeCreateDialog
      v-model:visible="showCreateForm"
      @create="getBarcodes"
    />
  </div>
</template>

<script>

import BarcodeTable from "@/components/barcodes/BarcodeTable";
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import {ADMIN_ROLE} from "@/shared/constants";
import useBarcodeFilter from "@/composables/filters/useBarcodeFilter";
import {reactive} from "vue";
import BarcodeCreateDialog from "@/components/barcodes/BarcodeCreateDialog.vue";
import BarcodeAdvancedFilter from "@/components/barcodes/BarcodeAdvancedFilter.vue";

export default {
  name: "TagView",
  components: {
    BarcodeCreateDialog,
    Toolbar,
    BarcodeTable,
    Button,
    BarcodeAdvancedFilter
  },
  setup() {
    const barcodeFilter = reactive(useBarcodeFilter());
    barcodeFilter.filters.deleted.value = false;
    barcodeFilter.pageable.sortField = "creationDate";
    barcodeFilter.pageable.sortOrder = -1;

    return {
      barcodeFilter
    }
  },
  data() {
    return {
      tags: [],
      totalItemsCount: 0,

      loading: false,
      showCreateForm: false
    }
  },
  created() {
    this.getBarcodes();
  },
  methods: {
    resetFilter() {
      this.barcodeFilter.reset();
      this.getBarcodes()
    },
    async getBarcodes() {
      this.isLoading = true;
      try {
        const {content, totalElements} = await this.$barcodeService.getAll(this.barcodeFilter.getQueryParams());
        this.tags = content;
        this.totalItemsCount = totalElements;
      } catch (e) {
        this.$emitter.emit("toast", {
          severity: "error",
          message: "error.global",
        });
      } finally {
        this.isLoading = false;
      }
    },
    onPageChange(event) {
      this.barcodeFilter.pageable.page = event.page;
      this.getBarcodes();
    }
  }
}
</script>
